<template>
  <div class="empty-state">
    <div class="empty-state-icon">
      <i :class="['fa-solid', icon]"></i>
    </div>
    <p class="empty-state-title">{{ title }}</p>
    <p v-if="subtitle" class="empty-state-subtitle">{{ subtitle }}</p>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
  icon: {
    type: String,
    default: 'fa-inbox',
  },
  title: {
    type: String,
    default: 'Keine Daten vorhanden',
  },
  subtitle: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.empty-state-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f1f5f9;
  margin-bottom: 18px;
}

.empty-state-icon i {
  font-size: 28px;
  color: #94a3b8;
}

.empty-state-title {
  font-size: 15px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 4px;
}

.empty-state-subtitle {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}
</style>
